import { smlSettingsTabs } from './smlSettingsTabs';
import { SMLSettingsTabDef } from './types';

/** SmartLinks and Outreach are on every plan, so every tab shows. */
export const useSMLSettingsTabs = (): SMLSettingsTabDef[] => smlSettingsTabs;
